import { Outlet } from 'react-router-dom';
import DocumentsProvider from '../../../providers/Documents';
import PageWrapper from '../../../components/PageWrapper';
import './Dashboard.styles.scss';

function Dashboard() {
  return (
    <PageWrapper>
      <DocumentsProvider>
        <Outlet />
      </DocumentsProvider>
    </PageWrapper>
  );
}

export default Dashboard;
